<template>
    <div class="col-lg-12" style="padding: 20px">
      <div class="main-card mb-3 card" style="margin-left: 10px">
        <div class="card-body">
          <h5 class="card-title">
            2025 Summer Camp 학습현황
            <div
              class="sub_title"
              style="
                margin-bottom: 20px;
                color: #333;
                font-size: 13px;
                border: 1px solid #ccc;
                background: #f8f8f8;
                height: 30px;
                text-align: right;
                position: absolute;
                right: 20px;
                top: 10px;
                padding: 2px 10px;
              "
            >
              2025 Summer Camp → 학습현황
            </div>
          </h5>
          <query-grid :config="config" ref="qg">
            <!-- <template #actions>
              <Create-Event ref="newSub" #default="m"> </Create-Event>
            </template> -->
            <template #resultactions=""
              ><!--추후 제공예정-->
  
              <div style="text-align: right">
                <!--button class="btn btn-danger"  @click="addHistory()" >2022 Summer Camp 테스트</button-->
                <!--button class="btn btn-danger" data-bs-toggle="modal" data-bs-target=".bd-example-modal-lg"
                @click="creatingMode()">2022 Summer Camp 신청하기</button-->
                <router-link to="/events/2025_Summer"
                  ><button class="btn btn-secondary">
                    신청목록
                  </button></router-link
                >
                <router-link to="/events/2025Summer"
                  ><button class="btn btn-secondary">
                    학습 게시판
                  </button></router-link
                >
                <!--router-link to="/events/2025Summer/history"
                  ><button class="btn btn-secondary">
                    게임참여현황
                  </button></router-link
                -->
              </div>
            </template>
  
            <template #items="props">
              <tr
                v-for="record in props.records"
                v-bind:key="record.id + record.timeStudy"
                :class="{ 'table-danger': record.is_deleted }"
              >
                 <td style="text-align: center"> 
                 {{ record.username }}
                 </td>                 
                <td style="text-align: center">
                  <EventStudyN :EventStudyN="record" :ref="'admusr' + record.studyNo" />
                </td>
                <td
                  style="text-align: center"
                  v-if="
                    this.$root.guiPerm != 'CLASS' &&
                    this.$root.guiPerm != 'ENTERPRISE'
                  "
                >
                  <Business v-if="record.t2" :biz="record.t2" />
                </td>
  
                <td style="text-align: center">
                  <Business v-if="record.t1" :biz="record.t1" />
                </td>
                <td style="text-align: center">
                  {{ record.datPlan }}시간
                </td>
                <td style="text-align: center">
                  {{ record.timeStudy }} 
                </td>
                <td style="text-align: center">{{ record.addi_data1 }}</td>
              <td style="text-align: center">{{ record.bitPoint }}</td>
                <td style="text-align: center">
                  {{ record.completeCnt }}
                </td>
                <td style="text-align: center">
                  {{ record.datStudy }}
                </td>
                <td>
                  <button
                    class="btn btn-warning btn-sm"
                    @click="this.$refs['admusr' + record.studyNo][0].openModal()" v-if="this.$root.guiPerm == 'ROOT'"
                  >
                    상세
                  </button>
                  <button
                    class="btn btn-danger btn-sm"
                    @click="deleteStudy(record)" v-if="this.$root.guiPerm == 'ROOT'"
                  >
                    삭제
                  </button>
                </td>
                
              </tr>
            </template>
          </query-grid>
        </div>
      </div>
    </div>
   
    <Tree
      :key="$route.path"
      :tree-data="this.$root.businesses"
      :selectable="['CLASS']"
      render-button
      :callback="selectedBiz"
      :selectedNode="{ id: selData.activeBusiness }"
      ref="biz"
    />
  </template>
  
  <script>
  // @ is an alias to /src
  
  import Tree from "../components/Tree";
  import treeBtn from "../components/treeBtn";
  import Business from "../components/Business";
  import QueryGrid from "../components/QueryGrid";
  import Student from "../components/detail_pages/Student";
  import EventStudyN from "../components/detail_pages/EventStudy";
  import axios from "axios";
  export default {
    name: "Home",
    components: {
      Tree,
      treeBtn,
      Business,
      EventStudyN,
      Student,
      QueryGrid,
    },
    mounted() {
      if (this.$route.query.type) {
        /*this.typeFilter = {};
          this.typeFilter[this.$route.query.type] = true;*/
        this.$refs.qg.pushSetting(
          "status_filter_" + this.$route.query.type,
          true
        );
      }
  
      if (this.$root.guiPerm == "CLASS" || this.$root.guiPerm == "ENTERPRISE") {
        this.$refs.qg.pushSetting("status_filter_ACTIVE", true);
        //this.config.columns.splice(0, 1);
      }
      //처음 로딩 시 학습일자 전날로 세팅하기 
      var moment = require('moment'); // moment 모듈불러오기
       var now = moment(); //오늘
      // var now = moment('2020-01-01'); //특정일 셋팅

      // //moment().add(number,String); 추가
      // //moment().subtract(number,String); 빼기

      // var tomorrow = moment().add(1,'days'); //내일
      var yesterday = moment().subtract(1,'days'); //어제
      
      // var addMonth = moment().add(1,'months'); //한달 뒤
      // var subMonth = moment().subtract(1,'months'); //한달 전
      // var addYear = moment().add(1,'years'); //일년 뒤
      // var subYear = moment().subtract(1,'years'); //일년 전

      //console.log("now:"+now);
      this.$refs.qg.pushSetting('date_filter_type','study_date');
      this.$refs.qg.pushSetting('date_filter_start',yesterday.format('YYYY-MM-DD'));
      this.$refs.qg.pushSetting('date_filter_end',yesterday.format('YYYY-MM-DD'));

  
      this.$refs.qg.search();
  
      this.$watch(
        () => this.$route.query.type,
        function (toQuery, previousQuery) {
          // react to route changes...
  
          this.$refs.qg.pushSetting("status_filter_ACTIVE", false);
          this.$refs.qg.pushSetting("status_filter_INACTIVE", false);
          this.$refs.qg.pushSetting("status_filter_EVENT", false);
          if (toQuery)
            this.$refs.qg.pushSetting("status_filter_" + toQuery, true);
  
          this.$refs.qg.search();
        }
      );
    },
    methods: {
      deleteStudy(record) {
        if (!confirm("정말로 삭제할까요")) return;
        axios.delete("/studies/eventStudy/" + record.studyNo).then((response) => {
          if (response.data.error) {
            $.notify(
              {
                // options
                message: "삭제할 수 없습니다. " + response.data.error,
              },
              {
                // settings
                type: "danger",
                z_index: 9999,
              }
            );
          } else {
            $.notify(
              {
                // options
                message: "삭제되었습니다.",
              },
              {
                // settings
                type: "success",
                z_index: 9999,
              }
            );
            this.$refs.qg.search();
          }
        });
      },
    },
    data() {
      return {
        config: {
          name: "이벤트 학습 현황",
          req_endpoint: "/studies/eventStudy/summer2025",
          default_limit: 20,
          search_fields: [
            {
              id: "businesses",
              name: "소속선택",
              type: "business", // business, date, datetime,
            },
            {
              id: "search",
              name: "키워드검색",
              type: "text",
              placeholder: "아이디/이름/연락처",
            },
            {
              id: "date_filter",
              name: "날짜검색",
              type: "date",
              filter_type: {
                study_date: "학습일",
                regi_date: "등록일",
              },
            },
          ],
          columns: [
            {
              id: "username",
              sortable: true,
              name: "아이디",
              excel_print: (v) => {
                return v.username;
              },
            },
            {
              id: "hanName",
              sortable: true,
              name: "이름",
              excel_print: (v) => {
                return v.name;
              },
            },
            {
              id: "biz",
              sortable: false,
              name: "학원",
              excel_print: (v) => {
                return v.t2.name;
              },
            },
            {
              id: "class",
              sortable: false,
              name: "클래스/캠퍼스",
              excel_print: (v) => {
                return v.t1.name;
              },
            },
            {
              id: "datPlan",
              sortable: true,
              name: "학습목표",
              excel_print: (v) => {
                return v.datPlan;
              },
            },
            {
              id: "timeStudy",
              sortable: true,
              name: "학습시간",
              excel_print: (v) => {
                return v.timeStudy;
              },
            },
            {
              id: "addi_data1",
              sortable: true,
              name: "학습일기",
              excel_print: (v) => {
                return v.addi_data1;
              },
            },
            {
              id: "bitPoint",
              sortable: true,
              name: "달성여부",
              excel_print: (v) => {
                return v.bitPoint;
              },
            },
            {
              id: "completeCnt",
              sortable: true,
              name: "누적달성",
              excel_print: (v) => {
                return v.completeCnt;
              },
            },
            {
              id: "datStudy",
              sortable: true,
              name: "학습일자",
              excel_print: (v) => {
                return v.datStudy;
              },
            },
            {
              id: "action",
              name: "관리",
            },
          ],
          disable_init_search: true,
        },
        selBiz: {
          name: "",
        },
        subscriptions: [],
        selData: {
          studyNo: "",
          name: "",
          username: "",
          id: "",
          datStudy: "",
          datPlan: "",
          timeStudy: "",
          intStudy: "",
          bitComplete: "",
        },
        changedData: {},
        selProduct: {},
        selectedSubscription: {
          id: 0,
        },
        products: [],
        creating: true,
      };
    },
  };
  </script>
  